'use client'

import { useState } from 'react'
import { useChatBotMessages } from '../../../../hooks/useChatBotMessages'
import { InputForm } from '../../../InputForm/InputForm'
import { LegalPolicies } from '../../../LegalPolicies/LegalPolicies'

export function ChatDialogFooter() {
	const { sendHumanMessage } = useChatBotMessages()

	const [message, setMessage] = useState('')

	const onInput = (newMessage: string) => {
		setMessage(newMessage)
	}

	const onSubmit = () => {
		sendHumanMessage({ messageContent: message })
		setMessage('')
	}

	return (
		<>
			<InputForm input={message} onInput={onInput} onSubmit={onSubmit} />
			<LegalPolicies />
		</>
	)
}
